/* eslint-disable spire/export-styles */
import { RichContent } from "@affinity/Overrides/Widgets/Basic/RichContent";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import AccordionSection from "@affinity/MobiusOverrides/AccordionSection/AccordionSection";
import translate from "@insite/client-framework/Translate";
import Accordion from "@insite/mobius/Accordion";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import * as React from "react";
import { FC } from "react";
import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const enum fields {
    title = "title",
    type = "type",
    sections = "sections",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        // check how to do simple collections
        [fields.sections]: SectionModel[];
    };
}

interface SectionModel {
    fields: {
        sectionTitle: string;
        sectionContent: string;
    };
}

const style = css`
    &&&& {
        display: flex;
        flex-direction: column;
        gap: ${rem(10)};
        @media (min-width: ${breakpointWidth("lg")}) {
            gap: ${rem(15)};
        }
        button,
        button:focus {
            display: flex;
            gap: ${rem(10)};
            padding: ${rem(20)} ${rem(15)};
            background: none;
            border-radius: ${rem(5)};
            border: 3px solid ${colours.lightBlue};
            background-color: transparent;
            @media (min-width: ${breakpointWidth("lg")}) {
                padding: ${rem(23)} ${rem(20)};
                border-radius: ${rem(8)};
            }
            span {
                font-size: ${rem(18)};
                @media (min-width: ${breakpointWidth("lg")}) {
                    font-size: ${rem(20)};
                }
            }
            svg {
                background-color: ${colours.darkBlue};
                border-radius: 50%;
                color: ${colours.lightGreen};
            }
        }
        button:focus,
        button:hover,
        [aria-expanded="true"] {
            border-color: ${colours.darkBlue};
        }
        dd {
            padding: 0 ${rem(15)};
        }
        p {
            font-size: ${rem(16)};
            line-height: 1.625em;
            @media (min-width: ${breakpointWidth("lg")}) {
                padding: 0 ${rem(20)};
                font-size: ${rem(18)};
            }
        }
    }
`;

export const AccordionWidget: FC<OwnProps> = ({ fields }) => {
    const accordionStyles = style;

    return (
        <ContentWrapper>
            {!!fields.title && (
                <Typography
                    variant="h3"
                    as="h2"
                    data-test-selector="PageTitle"
                    color={colours.black}
                    css={css`
                        margin-bottom: ${rem(20)};
                    `}
                >
                    {translate(fields.title)}
                </Typography>
            )}
            <Accordion headingLevel={3} title={fields.title} css={accordionStyles}>
                {fields.sections.map((section, index) => {
                    const data = { content: section.fields.sectionContent, padding: false };
                    return (
                        <AccordionSection key={index} title={section.fields.sectionTitle}>
                            <RichContent
                                css={css``}
                                fields={data}
                                zone=""
                                isLayout={false}
                                id=""
                                parentId=""
                                type=""
                                generalFields={[]}
                                translatableFields={{}}
                                contextualFields={{}}
                            />
                        </AccordionSection>
                    );
                })}
            </Accordion>
        </ContentWrapper>
    );
};
// Switch to zone??? Optimizely Question ***

export const ContentWrapper = styled.div<InjectableCss>`
    display: block;
    width: 100%;
    ${injectCss}// Keep this for flexible reuse
`;

const widgetModule: WidgetModule = {
    component: AccordionWidget,
    definition: {
        group: "Basic",
        icon: "rectangle-wide",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Accordion Label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.sections,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    return item.fields.sectionTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "sectionTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "sectionContent",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
